// Tiny fetch hook for read-only platform endpoints. No external deps.
import { useEffect, useState, useCallback, useRef } from "react";
import { platformGet } from "./platformClient";

export const useFetch = (path, { enabled = true } = {}) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const reqId = useRef(0);

  const reload = useCallback(async () => {
    if (!enabled || !path) {
      setData(null);
      setError(null);
      setLoading(false);
      return;
    }
    const current = ++reqId.current;
    setLoading(true);
    setError(null);
    try {
      const result = await platformGet(path);
      if (current === reqId.current) {
        setData(result);
        setLoading(false);
      }
    } catch (e) {
      if (current === reqId.current) {
        setError(e);
        setData(null);
        setLoading(false);
      }
    }
  }, [path, enabled]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { data, error, loading, reload };
};
